import { render } from "./index.vue?vue&type=template&id=b3cbf9b4"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=b3cbf9b4&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__